import type { ComponentProps } from "react"
import { DayPicker } from "react-day-picker"

import { buttonVariants } from "./button"
import { cn } from "~/lib/utils"

function Calendar({
	className,
	classNames,
	showOutsideDays = true,
	...props
}: ComponentProps<typeof DayPicker>) {
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			className={cn(
				"w-fit rounded-md bg-background-secondary p-2 text-text-sub",
				className
			)}
			classNames={{
				root: "w-fit rounded-md bg-background-secondary text-text-sub",
				months: "relative flex w-fit flex-col gap-4 sm:flex-row",
				month: "w-fit space-y-2",
				month_caption: "flex h-9 items-center justify-center px-8",
				caption_label: "text-sm font-medium text-text-main",
				nav: "absolute inset-x-1 top-1 flex items-center justify-between",
				button_previous: buttonVariants({
					variant: "ghost",
					size: "icon-sm",
					className: "text-icons hover:text-text-main"
				}),
				button_next: buttonVariants({
					variant: "ghost",
					size: "icon-sm",
					className: "text-icons hover:text-text-main"
				}),
				chevron: "size-4 fill-current",
				month_grid: "w-fit border-collapse",
				weekdays: "flex border-b border-stroke/60 pb-1",
				weekday:
					"flex size-8 items-center justify-center rounded-md text-xs font-medium text-text-small",
				week: "mt-1 flex w-fit",
				day: "relative size-8 p-0 text-center text-sm",
				day_button: buttonVariants({
					variant: "ghost",
					size: "icon-md",
					className: "font-normal text-text-sub hover:text-text-main"
				}),
				selected:
					"[&>button]:border [&>button]:border-orbit [&>button]:bg-active [&>button]:text-text-main [&>button]:hover:bg-active",
				today:
					"[&>button]:border [&>button]:border-stroke [&>button]:text-text-main",
				outside: "opacity-35 [&>button]:text-text-small",
				disabled: "pointer-events-none opacity-35 [&>button]:text-text-small",
				hidden: "invisible",
				...classNames
			}}
			{...props}
		/>
	)
}

export { Calendar }
